<template>
  <v-card>
    <v-list dense :expand="true"
            :class="{'v-list--folded': !drawerVisible}">
      <template v-if="advanced">
        <v-list-tile class="tab-tile tab-title-switch">
          <v-list-tile-action>
            <v-switch
              :class="{'tab__advanced-selector--folded': !drawerVisible}"
              :key="anIncreasingNumber"
              :input-value="$getParentEditor().state.advancedMode"
              @change="toggleAdvancedMode()"
              class="tab__advanced-selector"
            ></v-switch>
          </v-list-tile-action>
          <v-list-tile-content class="hidden-md-and-down">
            <v-list-tile-title>{{ $t('message.form.tab.enableAdvanceEditor') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider class="hidden-xs-only"></v-divider>
        <v-divider class="hidden-sm-and-up nx-form-divider" @click="toggleDisplayDrawer"></v-divider>
      </template>
      <nx-form-tab-element v-for="tab in tabs"
                           :key="tab.scope"
                           :fields="scopeFields(tab.scope) || {}"
                           :errors="scopeErrors(tab.scope)"
                           :warnings="scopeWarnings(tab.scope)"
                           :visible-scope="visibleScope"
                           v-on="$listeners"
                           v-bind="tab"
      ></nx-form-tab-element>
    </v-list>
  </v-card>
</template>

<script>
import NxFormTabElement from '@/modules/form/components/FormTabElement';
import UserEditorConfig from '@/modules/form/mixins/user-editor-config';

export default {
  name: 'nx-form-tabs',
  inject: {
    $getParentEditor: {
      default: null,
    },
  },
  mixins: [UserEditorConfig],
  components: {
    NxFormTabElement,
  },
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    advanced: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Object,
      default: () => {},
    },
    errors: {
      type: Array,
      default: () => [],
    },
    warnings: {
      type: Array,
      default: () => [],
    },
    visibleScope: {
      type: String,
    },
  },
  data: () => ({
    anIncreasingNumber: 0,
    drawerVisible: true,
  }),
  computed: {
    advancedMode() {
      return this.$getParentEditor().state.advancedMode;
    },
  },
  methods: {
    scopeFields(scopeTitle) {
      return this.fields[`$${scopeTitle}`];
    },
    scopeErrors(scopeTitle) {
      return this.errors.filter(e => e.scope === scopeTitle);
    },
    scopeWarnings(scopeTitle) {
      return this.warnings.filter(e => e.scope === scopeTitle);
    },
    toggleAdvancedMode() {
      this.$emit('toggleAdvancedMode');
      // v-switch sucks and changes it's internal state even if we haven't actually mutated the changes. We force it to
      // be redrawn so the state is the same as the stored in the store.
      this.$nextTick(() => { this.anIncreasingNumber += 1; });
    },
    toggleDisplayDrawer() {
      this.drawerVisible = !this.drawerVisible;
    },
  },
};
</script>
<style lang="stylus">
.nx-form-generator-tabs {
  position: fixed;
  width 100%

  @media (max-width: 600px) {
    max-width: calc(100% - 32px);
    bottom: 0;
    z-index: 12;
  }

  @media (min-width: 601px) {
    max-width: 18vw;
    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &.collapse {
      width: 56px;
    }
  }
}
#nx-form-generator-tabs {
  @media (max-width: 600px) {
    transform: translateY(0)!important;
    box-shadow: 0px -1px 8px rgba(0, 0, 0, 0.14);
  }
}
#nx-form-generator-tabs > .v-list.v-list--dense {
  max-height: calc(100vh - 120px);
  overflow: auto;

  @media (max-width: 600px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  }
}
#nx-form-generator-tabs > .v-list.v-list--folded {
  @media (max-width: 600px) {
    max-height: 40px;
    overflow: hidden;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  }
}
#nx-form-generator-tabs > .v-list.v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
  height: 36px;
  .v-list__tile__action {
    justify-content: center;
  }
}
.tab__advanced-selector {
  padding-top: 8px;
  @media (max-width: 600px) {
    &--folded {
      opacity:0;
      pointer-events: none;
    }
  }
}

.tab-title-switch {
  @media (max-width: 600px) {
    position: absolute;
    top: 5px;
    padding: 0;
    right: 0;
    z-index: 1;

    .v-list__tile {
      padding: 0;
    }
  }
}

.collapse .tab__advanced-selector {
  margin-left: -6px;
}

.nx-form-divider {
  display: block;
  width: 100%;
  height: 40px;
  flex: auto;
  max-height: none;
  position: relative;
  cursor: pointer;
  border: none;
  &:after {
    content: "";
    display: block;
    margin: 12px auto 0;
    background-color: #E9E9EF;
    border-radius: 8px;
    width: 82px;
    height: 4px;
  }
}
</style>
